const config = {
    BASE_URL: 'https://theskepper.com',
    API_BASE_URL: 'https://api.skepper.in',
};

export default config;